import React from 'react';
import './whatGPT3.scss';
import '../../App.scss'
import { Feature } from '../../components';

const WhatGPT3 = () => {
    return (
        <section className='gpt3__whatgpt3 section__margin' id='wgpt3'>
            <div className='gpt3__whatgpt3-feature'>
                <Feature
                    title='What is GPT-3'
                    text='We so opinion friends me message as delight. Whole front do of plate heard oh ought. His defective nor convinced residence own. Connection has put impossible own apartments boisterous. At jointure ladyship an insisted so humanity he. Friendly bachelor entrance to on by.' />
            </div>

            <div className='gpt3__whatgpt3-heading'>
                <h2 className='heading heading__secondary'>
                    The possibilities are beyond your imagination
                </h2>
                <p className='paragraph__component--red'>Explore The Library</p>
            </div>

            <div className='gpt3__whatgpt3-container'>
                <Feature
                    title='Chatbots'
                    text='We so opinion friends me message as delight. Whole front do of plate heard oh ought.' />
                <Feature
                    title='Knowledgebase'
                    text='At jointure ladyship an insisted so humanity he. Friendly bachelor entrance to on by. As put impossible own apartments.' />
                <Feature
                    title='Education'
                    text='At jointure ladyship an insisted so humanity he. Friendly bachelor entrance to on by. As put impossible own apartments.' />
            </div>
        </section>
    )
}

export default WhatGPT3